/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Footer_viewer = {
    readonly countryByCode: {
        readonly websiteNavigationSections: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"MenuSections_sections">;
        }>;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"FooterCountryPicker_viewer">;
    readonly " $refType": "Footer_viewer";
};
export type Footer_viewer$data = Footer_viewer;
export type Footer_viewer$key = {
    readonly " $data"?: Footer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Footer_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Footer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "country",
      "type": "String!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "countryByCode",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "country"
        }
      ],
      "concreteType": "Country",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "websiteNavigationSections",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "MenuSections_sections",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "FooterCountryPicker_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '371bbfe6a5f17d3314c3e1d7670d146e';
export default node;
